import http from "@utils/request";


// 测试数据库
export const getNodes = () => http({
  method: "GET",
  url: "/simulation/getNodes"
});

/**
 * 保存管道
 * @param {*} pipeline 
 * @returns 
 */
export const savePipeline = (filename,pipejson) => http({
  method: "POST",
  url: "/simulation/savePipeline",
  data:{
    filename,pipejson
  }
});

/** 导出、下载文件 */
export const exportToFile = (filename) => http({
  method: "get",
  url: "/simulation/exportToFile",
  data:{
    filename
  }
});

/**
 * 获取文件列表
 * @returns  
 */
export const getSaveFiles = () => http({
  method: "get",
  url: "/simulation/getSaveFiles"
});

/**
 * 加载json文件
 * @param {*} filename 
 * @returns 
 */
export const open = (filename,type) => http({
  method: "get",
  url: "/simulation/open",
  data:{
    filename,type
  }
});

/**
 * 进行模拟计算
 * @param {*} pipejson 
 * @returns 
 */
export const siumulateCalculate = (pipejson) => http({
  method: "post",
  url: "/simulation/siumulateCalculate",
  contentType:"default",
  data:pipejson
});

/**
 * 删除文件
 * @param {*}} filename 
 * @returns 
 */
export const delecteFile = (filename) => http({
  method: "post",
  url: "/simulation/delecteFile",
  data:{
    filename
  }
});

/**
 * 导出excel表格
 * @param {*} json 
 * @returns 
 */
export const exportToExcel = (json) => http({
  method: "post",
  url: "/simulation/exportToExcel",
  data:{
    json
  },
  responseType: 'arraybuffer'
});

